<div class="profile-photo">
    <div class="header-dialog">
        <span matDialogClose class="cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
              <path
                d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
                transform="translate(-7.873 -7.872)" />
            </svg>
          </span>
    </div>
    <div class="photo font-omicron-bold background-color-omicron color-img-photo" *ngIf="!existProfilePhoto">
        {{myHeaderProfile.doctorInitials}}
    </div>
    <img [src]="profilePhoto" alt="profile-photo.jpg" class="profile-photo-img" [ngClass]="coverImage? 'objectFitContain' : ''" *ngIf="existProfilePhoto">
    <app-file-selected *ngIf="isChangePhoto" [shouldUpdateProfilePhoto]="true"
        (fileSelectedResult)="changeProfilePhoto($event)" class="file-selected-style button-size-lateral-menu">
    </app-file-selected>
</div>